export default "__VITE_ASSET__DmCPNigD__"